var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"relacionados"}},[_vm._m(0),_c('div',{staticClass:"investments"},_vm._l((_vm.contents),function(investment){return _c('Empreendimento',{key:investment.title,staticClass:"investment",attrs:{"contents":investment}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('span',[_vm._v("Propriedades")]),_vm._v("relacionadas")])
}]

export { render, staticRenderFns }